import { render, staticRenderFns } from "./Public-Layout.vue?vue&type=template&id=a6dc06a0&"
import script from "./Public-Layout.vue?vue&type=script&lang=js&"
export * from "./Public-Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports